import { GalleryTheme, TenantDto } from '@nusign/picflow-backend-types';
import { loadFont } from '../../lib/load-font';

export const loadThemeFonts = (theme: GalleryTheme, tenant: TenantDto) => {
  if (theme.cover.title_typography.font_family) {
    loadFont(theme.cover.title_typography.font_family);
  } else if (tenant.default_cover_title_typography?.font_family) {
    loadFont(tenant.default_cover_title_typography.font_family);
  }
  if (theme.cover.paragraph_typography.font_family) {
    loadFont(theme.cover.paragraph_typography.font_family);
  }

  if (theme.section.title_typography.font_family) {
    loadFont(theme.section.title_typography.font_family);
  } else if (tenant.default_title_typography?.font_family) {
    loadFont(tenant.default_title_typography.font_family);
  }
  if (theme.section.paragraph_typography.font_family) {
    loadFont(theme.section.paragraph_typography.font_family);
  } else if (tenant.default_paragraph_typography?.font_family) {
    loadFont(tenant.default_paragraph_typography.font_family);
  }
};
